import React, { useState } from 'react';
import styles from './Navbar.module.css';
import { Button } from '../../core/Button';
import { ThemeToggleButton } from '../../utils/ThemeToggleButton';
import { Logo } from '../../core/Logo';

export const Navbar: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.logo}>
        <a href="/">
          <Logo size="medium" />
        </a>
      </div>
      <div className={styles.mobileControls}>
        <ThemeToggleButton />
        <div className={styles.hamburger} onClick={toggleMobileMenu}>
          <div />
          <div />
          <div />
        </div>
      </div>
      <div
        className={`${styles.menuContainer} ${
          isMobileMenuOpen ? styles.open : ''
        }`}
      >
        <button className={styles.closeButton} onClick={toggleMobileMenu}>
          <span>&times;</span>
        </button>
        <div className={styles.menu}>
          <a href="/pricing">Pricing</a>
        </div>
        <div className={styles.actions}>
          <div className={styles.desktopTheme}>
            <ThemeToggleButton />
          </div>
          <Button>
            <a href="/signup">Get Started</a>
          </Button>
        </div>
      </div>
    </nav>
  );
};
